import React, { useContext, useEffect, useState } from "react";
import { Menu } from "../Menu";
import { MenuLateral } from "../MenuLateral";
import { Notificacion } from "./Notificacion";
import { CuotasVerMas } from "../../../../functionalities/CuotasVerMas";
import { AppContext } from "../../../../Context/Context";

export const Notificaciones = () => {
    const id = atob(sessionStorage.getItem("dtpln"));
    const [state, fetchUserData] = useContext(AppContext);
    const [notificaciones, setNotificaciones] = useState([]);

    useEffect(() => {
        if (state.data !== null) {
            const planes = state.data.Usuario.Datos.Planes.Plan;
            const plan = planes.find(plan => plan.Id === id);
            if (plan && plan.Notificaciones) {
                setNotificaciones(plan.Notificaciones.Notificacion || []);
            }
        }
    }, [state]);

    useEffect(() => {
        new CuotasVerMas("#notificacion");
        let buttonVerMas = document.getElementById("verMas");
        let cuotasHidden = document.querySelectorAll(".hideItem");
        if (cuotasHidden.length < 3) {
            buttonVerMas.style.display = "none";
        } else {
            buttonVerMas.style.display = "block";
        }
    }, [notificaciones]);

    useEffect(() => {
        let buttonVerMas = document.getElementById("verMas");

        buttonVerMas.addEventListener("click", () => {
            let cuotasHidden = document.querySelectorAll(".hideItem");
            if (cuotasHidden.length < 4) {
                buttonVerMas.style.display = "none";
            }
            if (cuotasHidden.length > 0) {
                for (let index = 0; index < 3; index++) {
                    cuotasHidden[index].classList.remove("hideItem");
                    cuotasHidden[index].classList.add("showItem");
                }
            }
        });
    }, []);

    const handleRemoveNotification = (deletedId) => {
        setNotificaciones(prev => prev.filter(noti => noti.Id !== deletedId));

        state.data.Usuario.Datos.Planes.Plan = state.data.Usuario.Datos.Planes.Plan.map(plan => {
            if (plan.Id === id) {
                return {
                    ...plan,
                    Notificaciones: {
                        ...plan.Notificaciones,
                        Notificacion: plan.Notificaciones.Notificacion.filter(noti => noti.Id !== deletedId)
                    }
                };
            }
            return plan;
        });
    };

    return (
        <div>
            <Menu />
            <div className="wrap">
            <MenuLateral key={state.selectedPlan?.Id || "default-key"} />
                <div className="next-to-sidebar">
                    <div className="notificaciones">
                        <div className="notificaciones_mainDiv mt-doub mb-base">
                            <div className="notificaciones_mainDiv--user">
                                <p>Notificaciones</p>
                            </div>
                            <div className="separator--hor separatorPersonalizado mt-half"></div>
                            <div className="notificaciones_mainDiv--notificaciones mb-base">
                                {notificaciones !== null &&
                                    notificaciones !== undefined ? (
                                    notificaciones.map(notificacion => (
                                        <Notificacion
                                            key={notificacion.id}
                                            id={notificacion.Id}
                                            fecha={notificacion.Fecha}
                                            link={notificacion.Link}
                                            textoLink={notificacion.TextoLink}
                                            mensaje={notificacion.Mensaje}
                                            titulo={notificacion.Titulo}
                                            onDelete={handleRemoveNotification}
                                        />
                                    ))
                                ) : (
                                    <>
                                        {notificaciones === null ? (
                                            <div className="spinner-loader w-100 d-flex justify-content-center">
                                                <div
                                                    className="spinner-border text-amarillo text-warning mt-dbhf mb-doub align-self-center"
                                                    role="status"
                                                >
                                                </div>
                                            </div>
                                        ) : (
                                            <p className="my-base mx-half">
                                                No existen notificaciones
                                            </p>
                                        )}
                                    </>
                                )}
                            </div>
                            <button id="verMas">Ver más</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// import React, { useEffect, useState } from 'react'
// import { Menu } from '../Menu'
// import { Notificacion } from './Notificacion'
// import { CuotasVerMas } from '../../../../functionalities/CuotasVerMas';

// let notificaciones = [
//     {
//         "id": "1",
//         "Categoria": "Aviso",
//         "Title": "AVISO DE VENCIMIENTO",
//         "Fecha": "15/12/2020",
//         "Link": "",
//         "Descripcion": "Alerta de ganador del sorteo",
//         "Notifica": ""
//     },
//     {
//         "id": "2",
//         "Categoria": "Aviso",
//         "Title": "AVISO DE VENCIMIENTO",
//         "Fecha": "15/12/2020",
//         "Link": "",
//         "Descripcion": "Notificación de apertura de licitación",
//         "Notifica": ""
//     },
//     {
//         "id": "3",
//         "Categoria": "Aviso",
//         "Title": "AVISO DE VENCIMIENTO",
//         "Fecha": "15/12/2020",
//         "Link": "",
//         "Descripcion": "Notificador de ganador de licitación",
//         "Notifica": ""
//     },
//     {
//         "id": "4",
//         "Categoria": "Aviso",
//         "Title": "AVISO DE VENCIMIENTO",
//         "Fecha": "15/12/2020",
//         "Link": "",
//         "Descripcion": "Aviso de cambio de estado de carpeta",
//         "Notifica": ""
//     },
//     {
//         "id": "5",
//         "Categoria": "Aviso",
//         "Title": "AVISO DE VENCIMIENTO",
//         "Fecha": "15/12/2020",
//         "Link": "",
//         "Descripcion": "Aviso de vencimiento",
//         "Notifica": ""
//     },
//     {
//         "id": "6",
//         "Categoria": "Pago",
//         "Title": "AVISO DE VENCIMIENTO",
//         "Fecha": "15/12/2020",
//         "Link": "",
//         "Descripcion": "Aviso del próximo vencimiento",
//         "Notifica": ""
//     },
//     {
//         "id": "7",
//         "Categoria": "Pago",
//         "Title": "AVISO DE VENCIMIENTO",
//         "Fecha": "15/12/2020",
//         "Link": "",
//         "Descripcion": "Pagos ingresados",
//         "Notifica": ""
//     }
// ];

// export const Notificaciones = () => {

//     useEffect(() => {

//         new CuotasVerMas('#notificacion')
//         let buttonVerMas = document.getElementById('verMas');
//         let cuotasHidden = document.querySelectorAll('.hideItem');
//         console.log(cuotasHidden);
//         if (cuotasHidden.length < 3) {
//             buttonVerMas.style.display = 'none';
//         } else {
//             buttonVerMas.style.display = 'block'
//         }
//     }, [])

//     useEffect(() => {
//         let buttonVerMas = document.getElementById('verMas');

//         buttonVerMas.addEventListener('click', () => {
//             let cuotasHidden = document.querySelectorAll('.hideItem');
//             if (cuotasHidden.length < 4) {
//                 buttonVerMas.style.display = 'none';
//             }
//             if (cuotasHidden.length > 0) {
//                 for (let index = 0; index < 3; index++) {
//                     console.log(cuotasHidden[index]);
//                     cuotasHidden[index].classList.remove('hideItem');
//                     cuotasHidden[index].classList.add('showItem');
//                 }
//             }
//         });

//     }, [])
//     return (
//         <div>
//             <Menu />
//             <div className="notificaciones">
//                 <div className="notificaciones_mainDiv mt-doub mb-base">
//                     <div className="notificaciones_mainDiv--user">
//                         <p>Notificaciones</p>
//                         <div className="separator--hor mt-half mb-half"></div>
//                     </div>
//                     <div className="notificaciones_mainDiv--plan">
//                         <p>PLAN 84 cuotas Renegade SPORT 1.8 MT5 </p>
//                     </div>
//                     <div className="separator--hor separatorPersonalizado mt-half"></div>
//                     <div className="notificaciones_mainDiv--notificaciones mb-base">
//                         {notificaciones.map(notificacion => (
//                             <Notificacion key={notificacion.id} />
//                         ))}
//                     </div>
//                     <button id="verMas">Ver más</button>
//                 </div>
//             </div>
//         </div>
//     )
// }
